import React from "react";
import classes from "./LibraryPage.module.css";

// img
import book1 from "./assets/images/book1.jpg";
import book2 from "./assets/images/book2.jpg";
import book3 from "./assets/images/book3.jpg";
import book4 from "./assets/images/book4.jpg";
import book5 from "./assets/images/book3.jpg";
import book6 from "./assets/images/book4.jpg";

import alifbo from "./assets/pdf/matematika.pdf";
import PageName from "../../../admin/shared/components/PageName";

const data = [
  { id: 111, name: "Guess What!!!", img: book1, file: "" },
  { id: 112, name: "Odobnoma", img: book2, file: "" },
  { id: 113, name: "Atrof olam", img: book3, file: "" },
  { id: 114, name: "O'qish kitobi", img: book4, file: "" },
  { id: 115, name: "Matematika", img: book5, file: "" },
  { id: 116, name: "Texnologiya", img: book6, file: "" },
  { id: 117, name: "Guess What!!!", img: book1, file: "" },
  { id: 118, name: "Odobnoma", img: book2, file: "" },
  { id: 119, name: "Atrof olam", img: book3, file: "" },
  { id: 134, name: "O'qish kitobi", img: book4, file: "" },
  { id: 156, name: "Matematika", img: book5, file: "" },
  { id: 787, name: "Texnologiya", img: book6, file: "" },
];

const Library = () => {
  return (
    <>
      <PageName pageName={"Books"} totalRecords={data} />
      <div className={classes["wrapper"]}>
        {data.map((value) => {
          return (
            <div key={value.id} className={classes["box"]}>
              <img className={classes["img"]} src={value.img} alt="" />
              <h3 className={classes["text"]}>{value.name}</h3>
              <a target="_blank" href={alifbo}>
                <button className={classes["btn"]}>Download</button>
              </a>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Library;
